import { render, staticRenderFns } from "./SupportSection.vue?vue&type=template&id=01b46ab2&scoped=true&"
import script from "./SupportSection.vue?vue&type=script&lang=js&"
export * from "./SupportSection.vue?vue&type=script&lang=js&"
import style0 from "./SupportSection.vue?vue&type=style&index=0&id=01b46ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b46ab2",
  null
  
)

export default component.exports